import React from 'react';
import { Link } from 'react-router-dom';

function CookiePolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
        
        <Link to="/" className="inline-block text-primary hover:text-blue-700 mb-6">
          ← Back to Home
        </Link>

        <div className="bg-white rounded-lg shadow-md p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Introduction</h2>
            <p className="text-gray-700 leading-relaxed">
              This Cookie Policy explains how Classifieds.com uses cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">What are cookies?</h2>
            <p className="text-gray-700 leading-relaxed">
              Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Why do we use cookies?</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              We use cookies for a variety of reasons detailed below. Unfortunately, in most cases there are no industry standard options for disabling cookies without completely disabling the functionality and features they add to this site. It is recommended that you leave on all cookies if you are not sure whether you need them or not in case they are used to provide a service that you use.
            </p>
            
            <h3 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Types of Cookies We Use:</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
              <li><strong>Analytics Cookies:</strong> We use Google Analytics and similar tools to help us understand how visitors interact with our site.</li>
              <li><strong>Functionality Cookies:</strong> These allow the website to remember choices you make (such as your user name, language, or region) and provide enhanced features.</li>
            </ul>
          </section>

          <section className="bg-blue-50 border-l-4 border-blue-500 p-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Your Rights (GDPR & CCPA Compliance)</h2>
            <p className="text-gray-700 leading-relaxed mb-2">
              Under GDPR and CCPA regulations, you have the following rights:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
              <li>The right to be informed about our use of cookies</li>
              <li>The right to access personal data we hold about you</li>
              <li>The right to request deletion of your personal data</li>
              <li>The right to opt-out of the sale of your personal information (CCPA)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">How to Control Cookies</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You can choose to disable or selectively delete cookies through your browser settings. However, this may affect the functionality of our website. Alternatively, you can manage your cookie preferences using our Cookie Consent Manager:
            </p>
            
            <div className="bg-gray-100 rounded-lg p-4 mb-4">
              <h3 className="font-semibold text-gray-800 mb-2">Cookie Management Options:</h3>
              <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
                <li>Click the "Cookie Settings" button in the bottom-right corner of any page</li>
                <li>Use our Cookie Consent popup when you first visit</li>
                <li>For CCPA: Click "Do Not Sell My Personal Information"</li>
              </ul>
            </div>

            <p className="text-gray-700 leading-relaxed">
              Most web browsers allow some control of most cookies through the browser settings. Popular browsers include Chrome, Firefox, Safari, and Edge.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Third-Party Cookies</h2>
            <p className="text-gray-700 leading-relaxed">
              In some special cases, we also use cookies provided by trusted third parties. Our site currently uses Google Analytics, which is one of the most widespread and trusted analytics solutions on the web for helping us understand how you use the site and ways that we can improve your experience.
            </p>
          </section>

          <section className="bg-amber-50 border-l-4 border-amber-500 p-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Legal Requirements</h2>
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
              <li><strong>GDPR (General Data Protection Regulation):</strong> Applies to all EU citizens and residents</li>
              <li><strong>CCPA (California Consumer Privacy Act):</strong> Applies to California residents</li>
              <li><strong>ePrivacy Directive:</strong> European cookie law requiring prior consent for non-essential cookies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Changes to This Cookie Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update our Cookie Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Cookie Policy on this page. These changes are effective immediately after they are posted on this site.
            </p>
          </section>

          <section className="border-t pt-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-3">Contact Us</h2>
            <p className="text-gray-700 leading-relaxed">
              If you have any questions about this Cookie Policy, please contact us:
            </p>
            <div className="mt-4 space-y-2 text-sm text-gray-600">
              <p><strong>Email:</strong> privacy@classifieds.com</p>
              <p><strong>Last Updated:</strong> April 2026</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
